import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useT } from "@/lib/i18n";

const cell = "bg-[#090A0F] border-[#282D3D] font-mono text-sm rounded-sm h-9";

export const TyreTargetsEditor = ({ value, onChange }) => {
  const { t } = useT();
  const rows = value || [];
  const set = (i, k, v) => onChange(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  return (
    <div data-testid="tyre-targets-editor" className="space-y-2">
      <div className="grid grid-cols-[1fr_1fr_90px_90px_36px] gap-2 font-mono text-[10px] uppercase text-slate-500">
        <span>{t("tyre_brand")}</span><span>{t("tyre_model")}</span><span>{t("target_bar")}</span><span>{t("tolerance_bar")}</span><span />
      </div>
      {rows.map((r, i) => (
        <div key={i} data-testid={`tyre-target-row-${i}`} className="grid grid-cols-[1fr_1fr_90px_90px_36px] gap-2">
          <Input data-testid={`tyre-target-brand-${i}`} value={r.brand} onChange={(e) => set(i, "brand", e.target.value)} className={cell} />
          <Input data-testid={`tyre-target-model-${i}`} value={r.model} onChange={(e) => set(i, "model", e.target.value)} className={cell} />
          <Input data-testid={`tyre-target-value-${i}`} type="number" step="0.01" value={r.target ?? ""} onChange={(e) => set(i, "target", e.target.value)} className={cell} />
          <Input data-testid={`tyre-target-tol-${i}`} type="number" step="0.01" value={r.tolerance ?? ""} onChange={(e) => set(i, "tolerance", e.target.value)} className={cell} />
          <button type="button" data-testid={`tyre-target-remove-${i}`} onClick={() => onChange(rows.filter((_, j) => j !== i))}
            className="h-9 flex items-center justify-center text-slate-500 hover:text-[#FF3B30] hover:bg-[#282D3D] rounded-sm transition-colors duration-200"><Trash2 className="w-4 h-4" /></button>
        </div>
      ))}
      <button type="button" data-testid="tyre-target-add-btn" onClick={() => onChange([...rows, { brand: "", model: "", target: "", tolerance: 0.05 }])}
        className="flex items-center gap-1.5 px-3 py-1.5 border border-dashed border-[#282D3D] hover:border-[#10B981] rounded-sm font-mono text-xs uppercase text-slate-400 hover:text-white transition-colors duration-200">
        <Plus className="w-3.5 h-3.5" /> {t("add_target")}
      </button>
    </div>
  );
};

export const cleanTargets = (rows) => (rows || [])
  .filter((r) => (r.brand || "").trim() && r.target !== "" && r.target != null)
  .map((r) => ({ brand: r.brand.trim(), model: (r.model || "").trim(), target: Number(r.target), tolerance: r.tolerance === "" || r.tolerance == null ? 0.05 : Number(r.tolerance) }));
